import React from "react";

export default function Footer() {
    return(
        <footer> 
            This page was coded by {" "}
            <a href="https://www.linkedin.com/in/tshegofatso-morapama-a56631227/?trk=public-profile-join-page">Tshegofatso Morapama </a>
            
             and open sourced on {" "}
              <a href="https://github.com/TshegoMorapama/Tshego-react-hosting">
                Github
            </a>
        </footer>
    );
}